<template>
    <div>      
       <sidebar></sidebar>
    <div class="page">
      <!-- navbar-->
          <headermenu></headermenu>
      <!-- Counts Section -->

      <!-- Header Section-->
      <section class="dashboard-header section-padding">
        <div class="container-fluid">
          <div class="row d-flex align-items-md-stretch">
            <!-- To Do List-->
            <div class="col-12">
              <div class="card to-do">
                <h2 class="display h4">General Setting Config.</h2>
                <p>Please select module for access/change.</p>
                <ul class="check-lists list-unstyled">
                  <li class="d-flex align-items-center"> 
                    <input type="checkbox" id="list-1" name="list-1" class="form-control-custom">
                    <label for="list-1">Similique sunt in culpa qui officia</label>
                  </li>
                  <li class="d-flex align-items-center"> 
                    <input type="checkbox" id="list-2" name="list-2" class="form-control-custom">
                    <label for="list-2">Ed ut perspiciatis unde omnis iste</label>
                  </li>
                  <li class="d-flex align-items-center"> 
                    <input type="checkbox" id="list-3" name="list-3" class="form-control-custom">
                    <label for="list-3">At vero eos et accusamus et iusto </label>
                  </li>
                  <li class="d-flex align-items-center"> 
                    <input type="checkbox" id="list-4" name="list-4" class="form-control-custom">
                    <label for="list-4">Explicabo Nemo ipsam voluptatem</label>
                  </li>
                  <li class="d-flex align-items-center"> 
                    <input type="checkbox" id="list-5" name="list-5" class="form-control-custom">
                    <label for="list-5">Similique sunt in culpa qui officia</label>
                  </li>
                  <li class="d-flex align-items-center"> 
                    <input type="checkbox" id="list-6" name="list-6" class="form-control-custom">
                    <label for="list-6">At vero eos et accusamus et iusto </label>
                  </li>
                  <li class="d-flex align-items-center"> 
                    <input type="checkbox" id="list-7" name="list-7" class="form-control-custom">
                    <label for="list-7">Similique sunt in culpa qui officia</label>
                  </li>
                  <li class="d-flex align-items-center"> 
                    <input type="checkbox" id="list-8" name="list-8" class="form-control-custom">
                    <label for="list-8">Ed ut perspiciatis unde omnis iste</label>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div> 
      </section>


      <footer class="main-footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">
              <p>Your company &copy; 2017-2019 - Logged as : </p>
            </div>
            <div class="col-sm-6 text-right">
               <div class="copyrights">
            <p>&copy; 2018 - DCSCloud <a href="http://www.dcscloudsolutions.com" class="external"> an Enterprise resource planner.</a></p>
            <!-- Please do not remove the backlink to us unless you support further theme's development at https://bootstrapious.com/donate. It is part of the license conditions. Thank you for understanding :)-->
               </div>
            </div>
          </div>
        </div>
      </footer>
    </div>

    </div>


</template>


<script>
import headermenu from '@/components/supportcomp/headermenu.vue'      
import sidebar from '@/components/supportcomp/sidebar.vue'


export default {
  name: 'general_settings',
  data () {
    return {
      msg: '',
      sideBarVisible : false,
      security_obj : '',
      modalnotify_view : false,
      modal_msg : '',   
      modal_title : '',
      ajax_loader : false        
    }
  },
  components: {
      headermenu,
      sidebar
   },
methods: {
    
    
     setSecurity : function (){
              var MstObj = this;
         var object_data = {"module_name":'general_settings'};
         view_spinner();
         call_Ajax("page_security",object_data).then(function (data){
              close_spinner();

                       MstObj.security_obj = data;
                    if (!data.resaccess.view)
                        {
 							notify_notauthz()
                        }

              
         })
         .fail(function(){
             close_spinner(); 
         });
         
   
      } //

  },
mounted : function () {
       var x = this;
     setTimeout(function(){ x.setSecurity(); }, 200);
  
}   
                
}

</script>


// WEBPACK FOOTER //
// src/components/general/general-settings.vue